var map = {
	"./animal-1.png": "0596",
	"./boat-1.png": "0eb4",
	"./boat-2.png": "f9b8",
	"./car-1.png": "011a",
	"./item-1.png": "60d2",
	"./machine-1.png": "30a6",
	"./staff-1.png": "1a27",
	"./truck-1.png": "b22e",
	"./truck-2.png": "b97e",
	"./truck-3.png": "d23d",
	"./watch-1.png": "cd3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2566";